"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateByKey = exports.STATE_CLOSED = exports.STATE_GOAL_REACHED = exports.STATE_REFUNDING = exports.STATE_FUNDING = exports.STATE_PENDING = void 0;
exports.STATE_PENDING = 'Pending';
exports.STATE_FUNDING = 'Funding';
exports.STATE_REFUNDING = 'Refunding';
exports.STATE_GOAL_REACHED = 'GoalReached';
exports.STATE_CLOSED = 'Closed';
const states = [
    exports.STATE_PENDING,
    exports.STATE_FUNDING,
    exports.STATE_REFUNDING,
    exports.STATE_GOAL_REACHED,
    exports.STATE_CLOSED,
];
function getStateByKey(stateKey) {
    return states[stateKey];
}
exports.getStateByKey = getStateByKey;
//# sourceMappingURL=hatch-states.js.map